import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Signup from './parts/Signup';

function UserAdd() {
  return (
    <Container fluid className="h-100 mt-4">
      <Row>
        <Col>
          <h3>ユーザ登録</h3>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Signup admin={false} />
        </Col>
      </Row>
    </Container>
  );
}

export default UserAdd;
